import { render } from "./CardGallery.vue?vue&type=template&id=15c68b70&scoped=true"
import script from "./CardGallery.vue?vue&type=script&lang=js"
export * from "./CardGallery.vue?vue&type=script&lang=js"

import "./CardGallery.vue?vue&type=style&index=0&id=15c68b70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c68b70"]])

export default __exports__